// extracted by mini-css-extract-plugin
export default {"popupBody":"Contact_popupBody__gU8AY","closeBtn":"Contact_closeBtn__KuYNy","callAlert":"Contact_callAlert__wHwDj"};